/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestResult } from './AutoTestResult';
const AutoTestResultWithExtraDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['assignmentId', codecNumber, 'assignment_id'],
    ['courseId', codecNumber, 'course_id'],
]), AutoTestResult);
export class AutoTestResultWithExtraData extends AutoTestResult {
    static decode(input) {
        return AutoTestResultWithExtraDataParser.decode(input).map(res => new AutoTestResultWithExtraData(res));
    }
    static unsafeDecode(input) {
        return AutoTestResultWithExtraData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestResultWithExtraDataParser.encode(data);
    }
    static schema() {
        return AutoTestResultWithExtraDataParser.schema();
    }
}
